<div class="plan-container pb-0">
    <ul class="plan-timeline">
        <div class="vertical-line">
            <li class="plan-timeline-item-first-2023">
                <webu-plan-display [plan]="transitionPlans[0]" [isTransitionPlan]="true"></webu-plan-display>
            </li>

            <li class="plan-timeline-item-second-2023 pt-2 mt-5">
                <div class="vertical-line-arrowdown"></div>
                <webu-plan-display [plan]="transitionPlans[1]" [isTransitionPlan]="true"></webu-plan-display>
            </li>
        </div>
    </ul>
</div>